exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._37Ql83fSTKOPEc{align-items:flex-start;display:flex;flex-direction:row;justify-content:space-between;margin:0 16px 0 8px}._12R7FIPlcbS_PP{padding-bottom:16px;padding-left:8px}._2MnTDSwfGWAPv_{margin:-8px 0 16px}._1iDzfp5SzeArAA{flex:0 0 auto;padding-top:40px;width:264px}@media only screen and (max-width:711px),only screen and (max-width:1091px) and (min-width:712px){._1iDzfp5SzeArAA{display:none}}@media only screen and (max-width:991px),only screen and (max-width:1371px) and (min-width:992px){._1iDzfp5SzeArAA._13SC-jLk3AXL-N{display:none}}._3Kjkq_httzI5dw{flex:0 0 auto;width:436px}", ""]);

// exports
exports.locals = {
	"dueDateSection": "_37Ql83fSTKOPEc",
	"dueDateCard": "_12R7FIPlcbS_PP",
	"dueList": "_2MnTDSwfGWAPv_",
	"scrollNavContainer": "_1iDzfp5SzeArAA",
	"pinnedBoardsMenu": "_13SC-jLk3AXL-N",
	"dueDateLists": "_3Kjkq_httzI5dw"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2772/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/team-cards-due-section.less
// module id = 5yQa
// module chunks = 13